var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'ar-switch',
    _vm.realVal ? 'on' : 'off',
    _vm.disabled && 'disabled',
    ("ar-switch--size-" + _vm.size) ],on:{"click":_vm.handleSwitchClick}},[_c('div',{class:['ball', _vm.realVal ? 'right-align' : 'left-align']}),_vm._v(" "),(!_vm.withoutText)?_c('ar-text',{class:['on-text', _vm.realVal && 'display'],attrs:{"size":"xxxs","text":"ON","weight":"bold"}}):_vm._e(),_vm._v(" "),(!_vm.withoutText)?_c('ar-text',{class:['off-text', !_vm.realVal && 'display'],attrs:{"size":"xxxs","text":"OFF","weight":"bold"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }